import MyImage from '@/shared/components/myImage'

import { getImgURL } from '@/shared/utils'

type SquadsTeamCardProps = {
  data?: {
    sFullName?: string
    _id?: string
    sTitle?: string
    sFirstName?: string
    oImg?: { sUrl?: string }
  }
  title?: string
  activeTeam?: string
  isHeading?: boolean
  playerLength?: number
}

const SquadsTeamCard = ({
  data,
  title,
  activeTeam = '',
  isHeading = false,
  playerLength
}: SquadsTeamCardProps) => {
  return (
    <div
      className={`${' min-w-[185px] md:w-full flex items-center gap-3 md:gap-4 rounded-none border-x md:border-x-0 md:border-b border-tabBorder px-4 py-3 md:py-5'} ${isHeading && '!pl-0'} ${
        title && 'h-12 font-semibold text-lg border-b border-b-c'
      } ${!title && 'cursor-pointer'} ${
        activeTeam === data?._id
          ? ' dark:bg-seriesGradient bg-white text-primary-500 md:text-t-origin !border-l-4 border-l-subSectionText pl-4 md:pl-6 '
          : ' bg-transparent border-l-0'
      } `}
    >
      {!title && (
        <div className={`w-9 h-9 md:w-10 md:h-10 rounded-full overflow-hidden flex-shrink-0`}>
          <MyImage
            src={data?.oImg?.sUrl ? getImgURL(data?.oImg?.sUrl) : ''}
            alt={data?.sFullName}
            className="aspect-square rounded-full"
            placeholderType="team"
            width={40}
            height={40}
          />
        </div>
      )}
      <div>
        <h3
          className={`text-xs text-textOffWhite md:text-base leading-none font-medium mb-0 ${
            title || isHeading ? 'text-nowrap' : 'line-clamp-1'
          }`}
        >
          {title || data?.sFullName || data?.sTitle || data?.sFirstName}
        </h3>
        {playerLength && (
          <p className="text-xs md:text-sm mb-0 mt-0.5 text-textDselected font-normal">
            {playerLength} Players
          </p>
        )}
      </div>
    </div>
  )
}

export default SquadsTeamCard
